import { render, staticRenderFns } from "./TotalPriceRow.vue?vue&type=template&id=1cb80281&scoped=true"
import script from "./TotalPriceRow.vue?vue&type=script&lang=ts"
export * from "./TotalPriceRow.vue?vue&type=script&lang=ts"
import style0 from "./TotalPriceRow.vue?vue&type=style&index=0&id=1cb80281&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb80281",
  null
  
)

export default component.exports